/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import SifCountry from 'linced-admin/enums/sif-country';
import { filterValue } from 'linced-admin/utils/filtering';

export default class ZonesController extends Controller {
  @action
  setFilterVal(value) {
    this.filterVal = value;
  }

  @action
  setZoneNewOpen(value) {
    this.zoneNewOpen = value;
  }

  queryParams = ['country'];
  @tracked
  country = SifCountry.AUSTRALIA;
  SifCountry = SifCountry;

  // Attrs
  // filterVal provides the params entered into the zone filter box.
  @tracked filterVal = '';

  // Services
  @service
  store;

  // State
  @tracked
  newZone = null;

  @tracked
  zoneNewOpen = false;

  // Methods
  /**
   * filteredZones filters zones based on the user's filter.
   */
  @computed('model.zones.[]', 'filterVal')
  get filteredZones() {
    if (isEmpty(this.filterVal)) {
      return this.model.zones;
    }

    return this.model.zones.filter((zone) => {
      return filterValue(zone.label, DataType.STRING, this.filterVal);
    });
  }

  @action
  changeCountry(country) {
    this.country = country.value;
  }

  @action
  onCreate(zone) {
    this.newZone = zone;
    this.zoneNewOpen = false;
  }
}
